/**
 * Schema of ResponsavelConfigEmail
 * @author gabrielbgil
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import ResponsavelConfigEmail from '@/model/resource/ResponsavelConfigEmail'

export default (model: ResponsavelConfigEmail): Schema => ({
  responsavel: {
    content: model.responsavel && model.responsavel.$id,
    input: InputType.SELECT,
  },

  statusEmail: {
    content: model.statusEmail && model.statusEmail.$id,
    input: InputType.SELECT,
    meta: {
      required: true,
    },
  },

  ocorrencia: {
    content: model.ocorrencia && model.ocorrencia.$id,
    input: InputType.SELECT,
  },

  idConfigEmailPk: {
    content: model.idConfigEmailPk,
    editable: false,
  },

  mensagem: {
    content: model.mensagem,
    input: InputType.TEXTAREA,
    meta: {
      required: true,
      maxlength: '2000',
      rows: '2',
    },
  },

  ativo: {
    content: bool(model.ativo),
    hidden: true,
    editable: true,
    input: InputType.CHECKBOX,
  },
})
